import { defineComponent as a, openBlock as r, createBlock as l, unref as p, mergeProps as c, withCtx as i, createElementVNode as e } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const d = /* @__PURE__ */ a({
  name: "IconArrowDownRightInCircle",
  __name: "IconArrowDownRightInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (h, t) => (r(), l(p(m), c(o, { "view-box": "0 0 24 24" }), {
      default: i(() => [...t[0] || (t[0] = [
        e("path", { d: "M3.75 12a8.25 8.25 0 1 0 16.5 0 8.25 8.25 0 0 0-16.5 0m-1.5 0c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12" }, null, -1),
        e("path", { d: "M14.47 15.53a.75.75 0 0 0 1.06-1.06l-6-6a.75.75 0 0 0-1.06 1.06l6 6" }, null, -1),
        e("path", { d: "M10.293 14.614a.75.75 0 0 0 0 1.5h4.571a1.25 1.25 0 0 0 1.25-1.25v-4.571a.75.75 0 1 0-1.5 0v4.321h-4.321" }, null, -1),
        e("path", { d: "M10.293 16.114a.75.75 0 0 1 0-1.5h3.26L8.47 9.53a.75.75 0 1 1 1.06-1.06l5.084 5.084v-3.261a.75.75 0 1 1 1.5 0v4.571a1.25 1.25 0 0 1-1.25 1.25h-4.571" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
